export function getAuthUserInfo() {
  return JSON.parse(localStorage.getItem("user"));
}
